export const GENERIC_ERROR_MESSAGE = "Attenzione! Si è verificato un errore. Riprovare più tardi.";

/**
 * Estrae il messaggio d'errore "custom" inviato dal backend, gestendo le varie
 * forme con cui un errore può presentarsi nel progetto:
 *  - useFetchJSON: `error.value` = oggetto JSON parsato (es. `{ messages: ["..."] }` o `{ message: "..." }`),
 *    oppure una stringa grezza (es. "Bad Request") quando la risposta non è JSON;
 *  - axios: `error.response.data` con `messages`/`message`;
 *  - Error lanciati manualmente (es. openPdfFromUrl/downloadFile): `error.message`.
 *
 * Se non trova un messaggio valido restituisce il messaggio generico (`fallback`),
 * così non mostriamo mai stringhe grezze tipo "Bad Request" all'utente.
 */
export function getErrorMessage(error: unknown, fallback: string = GENERIC_ERROR_MESSAGE): string {
  if (!error) return fallback;

  // axios espone il corpo della risposta sotto error.response.data
  const source = (error as { response?: { data?: unknown } })?.response?.data ?? error;

  // formato principale del backend: { messages: [...] }
  const messages = (source as { messages?: unknown })?.messages;
  if (Array.isArray(messages)) {
    const joined = messages.filter(Boolean).join(", ").trim();
    if (joined) return joined;
  }

  // formato alternativo: { message: "..." } oppure Error.message
  const message = (source as { message?: unknown })?.message;
  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }

  return fallback;
}
